<template>
  <div class="propertyoffice">
    <div class="header">
      <div class="title">物业服务</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="logo">
          <img :src="ResidentOffice1" alt="" />
        </div>
        <div class="position">
          <img :src="ResidentOffice2" alt="" />
          <img :src="ResidentOffice3" alt="" />
          <img :src="ResidentOffice4" alt="" />
        </div>
      </div>

      <div class="right">
        随时随地在线完成水电费、物业费、停车费等日常费用的缴纳，省时省力又方便。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import ResidentOffice1 from "../../../../assets/product/ResidentOffice1.png";
import ResidentOffice2 from "../../../../assets/product/ResidentOffice2.png";
import ResidentOffice3 from "../../../../assets/product/ResidentOffice3.png";
import ResidentOffice4 from "../../../../assets/product/ResidentOffice4.png";

export default {
  setup() {
    return reactive({
      ResidentOffice1: ResidentOffice1,
      ResidentOffice2: ResidentOffice2,
      ResidentOffice3: ResidentOffice3,
      ResidentOffice4: ResidentOffice4,
    });
  },
};
</script>

<style scoped>
.propertyoffice {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left {
  display: flex;
  position: relative;
}
.body .left .logo img {
  width: 332px;
  margin-right: 20px;
}
.body .left .position img {
  width: 236px;
  position: absolute;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
    width: 480px;
    font-size: 16px;
    color: #3D3D3D;
    line-height: 24px;
}
</style>
